<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7917 2.5C15.51 2.5 16.1988 2.78534 16.7067 3.29325C17.2147 3.80116 17.5 4.49004 17.5 5.20833V10.9408C17.4998 11.4378 17.3023 11.9144 16.9508 12.2658L12.2667 16.9508C12.0926 17.1249 11.8859 17.2631 11.6584 17.3573C11.4309 17.4515 11.1871 17.5 10.9408 17.5H5.20833C4.49004 17.5 3.80116 17.2147 3.29325 16.7067C2.78534 16.1988 2.5 15.51 2.5 14.7917V5.20833C2.5 4.49004 2.78534 3.80116 3.29325 3.29325C3.80116 2.78534 4.49004 2.5 5.20833 2.5H14.7917ZM14.7917 3.75H5.20833C5.01682 3.75 4.82719 3.78772 4.65025 3.86101C4.47332 3.9343 4.31255 4.04172 4.17714 4.17714C4.04172 4.31255 3.9343 4.47332 3.86101 4.65025C3.78772 4.82719 3.75 5.01682 3.75 5.20833V14.7917C3.75 15.5967 4.40333 16.25 5.20833 16.25H10.8333V13.5417C10.8333 12.8499 11.098 12.1843 11.5731 11.6815C12.0482 11.1786 12.6977 10.8767 13.3883 10.8375L13.5417 10.8333H16.25V5.20833C16.25 4.82156 16.0964 4.45063 15.8229 4.17714C15.5494 3.90365 15.1784 3.75 14.7917 3.75ZM15.3658 12.0833H13.5417C13.1755 12.0834 12.8228 12.2211 12.5536 12.4692C12.2843 12.7173 12.1183 13.0576 12.0883 13.4225L12.0833 13.5417V15.3658L15.3658 12.0833Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Note',
} as DefineComponent
</script>
